export const version = "random/5.5.0";
//# sourceMappingURL=_version.js.map